import React from 'react';
import { SimpleCarousel } from '@metarouter-private/mr-mui';
import useViolationEventsCarouselProps from './useViolationEventsCarouselProps';
import CenteredLoader from 'app/components/CenteredLoader';

export default function ViolationEventsCarousel() {
  const { loading, items } = useViolationEventsCarouselProps();

  if (loading) {
    return <CenteredLoader />;
  }

  return <SimpleCarousel items={items} />;
}
